import { getItemMaker } from "./tools";

const tab = getItemMaker("anvil expansions");
export const anvilExpansions = [
  tab("Anvil Tab 2"),
  tab("Anvil Tab 3"),
  tab("Anvil Tab 4"),
  tab("Anvil Tab 5"),
  tab("Anvil Tab 6"),
];

const bag = getItemMaker("inventory bags");
export const inventoryBags = [
  bag("Inventory Bag A"),
  bag("Inventory Bag B"),
  bag("Inventory Bag C"),
  bag("Inventory Bag D"),
  bag("Inventory Bag E"),
  bag("Inventory Bag F", "InvBag6"),
  bag("Inventory Bag G"),
  bag("Inventory Bag H"),
  bag("Snakeskinventory Bag", "InvBag100"),
  bag("Totally Normal and not fake Bag", "InvBag101"),
  bag("Blunderbag", "InvBag102"),
  bag("Sandy Satchel", "InvBag103"),
  bag("Bummo Bag"),
  bag("Capitalist Case"),
  bag("Wealthy Wallet"),
  bag("Prosperous Pouch"),
  bag("Sack of Success"),
  bag("Shivering Sack"),
  bag("Mamooth Hide Bag"),
  bag("Peeper Pouch"),
  bag("4th Anniversary Bag", "InvBag112"),
  bag("Inventory Bag U"),
  bag("Inventory Bag V"),
  bag("Inventory Bag W"),
  bag("Inventory Bag X"),
  bag("Inventory Bag Y"),
  bag("Inventory Bag Z"),
];

const pouch = getItemMaker("capacity pouches");
export const capacityPouches = [
  pouch("Mini Materials Pouch"),
  pouch("Cramped Material Pouch"),
  pouch("Small Material Pouch"),
  pouch("Average Material Pouch"),
  pouch("Sizable Materials Pouch"),
  pouch("Big Materials Pouch"),
  pouch("Large Materials Pouch"),
  pouch("Massive Materials Pouch"),
  pouch("Volumetric Matty Pouch"),
  pouch("Colossal Matty Pouch"),
  pouch("Gargantuan Matty Pouch"),
  pouch("Herculean Matty Pouch"),

  pouch("Miniscule Food Pouch"),
  pouch("Cramped Food Pouch"),
  pouch("Small Food Pouch"),
  pouch("Average Food Pouch"),
  pouch("Sizable Food Pouch"),
  pouch("Big Food Pouch"),
  pouch("Large Food Pouch"),
  pouch("Massive Food Pouch"),
  pouch("Volumetric Food Pouch"),
  pouch("Colossal Food Pouch"),
  pouch("Gargantuan Food Pouch"),
  pouch("Herculean Food Pouch"),

  pouch("Miniature Choppin Pouch"),
  pouch("Cramped Choppin Pouch"),
  pouch("Small Choppin Pouch"),
  pouch("Average Choppin Pouch"),
  pouch("Sizable Choppin Pouch"),
  pouch("Big Choppin Pouch"),
  pouch("Large Choppin Pouch"),
  pouch("Massive Choppin Pouch"),
  pouch("Volumetric Chopping Pouch"),
  pouch("Colossal Chopping Pouch"),
  pouch("Gargantuan Chopping Pouch"),
  pouch("Herculean Chopping Pouch"),

  pouch("Miniature Mining Pouch"),
  pouch("Cramped Mining Pouch"),
  pouch("Small Mining Pouch"),
  pouch("Average Mining Pouch"),
  pouch("Sizable Mining Pouch"),
  pouch("Big Mining Pouch"),
  pouch("Large Mining Pouch"),
  pouch("Massive Mining Pouch"),
  pouch("Volumetric Mining Pouch"),
  pouch("Colossal Mining Pouch"),
  pouch("Gargantuan Mining Pouch"),
  pouch("Herculean Mining Pouch"),

  pouch("Cramped Fish Pouch"),
  pouch("Small Fish Pouch"),
  pouch("Average Fish Pouch"),
  pouch("Sizable Fish Pouch"),
  pouch("Big Fish Pouch"),
  pouch("Large Fish Pouch"),
  pouch("Massive Fish Pouch"),
  pouch("Volumetric Fish Pouch"),
  pouch("Colossal Fish Pouch"),
  pouch("Gargantuan Fish Pouch"),
  pouch("Herculean Fish Pouch"),

  pouch("Cramped Bug Pouch"),
  pouch("Small Bug Pouch"),
  pouch("Average Bug Pouch"),
  pouch("Sizable Bug Pouch"),
  pouch("Big Bug Pouch"),
  pouch("Large Bug Pouch"),
  pouch("Massive Bug Pouch"),
  pouch("Volumetric Bug Pouch"),
  pouch("Colossal Bug Pouch"),
  pouch("Gargantuan Bug Pouch"),
  pouch("Herculean Bug Pouch"),

  pouch("Small Critter Pouch"),
  pouch("Sizable Critter Pouch"),
  pouch("Big Critter Pouch"),
  pouch("Large Critter Pouch"),
  pouch("Massive Critter Pouch"),
  pouch("Volumetric Critta Pouch"),
  pouch("Colossal Critta Pouch"),
  pouch("Gargantuan Critta Pouch"),
  pouch("Herculean Critta Pouch"),

  pouch("Small Soul Pouch"),
  pouch("Sizable Soul Pouch"),
  pouch("Big Soul Pouch"),
  pouch("Large Soul Pouch"),
  pouch("Massive Soul Pouch"),
  pouch("Volumetric Soul Pouch"),
  pouch("Colossal Soul Pouch"),
  pouch("Gargantuan Soul Pouch"),
  pouch("Herculean Soul Pouch"),
];

const chest = getItemMaker("storage chests");
export const storageChests = [
  chest("Storage Chest 1", "InvStorage1"),
  chest("Storage Chest 2", "InvStorage2"),
  chest("Storage Chest 3", "InvStorage3"),
  chest("Storage Chest 4", "InvStorage4"),
  chest("Storage Chest 5", "InvStorage5"),
  chest("Storage Chest 6", "InvStorage6"),
  chest("Storage Chest 7", "InvStorage7"),
  chest("Storage Chest 8", "InvStorage8"),
  chest("Storage Chest 9", "InvStorage9"),
  chest("Storage Chest 10", "InvStorage10"),
  chest("Storage Chest 11", "InvStorage11"),
  chest("Storage Chest 12", "InvStorage12"),
  chest("Storage Chest 13", "InvStorage13"),
  chest("Storage Chest 14", "InvStorage14"),
  chest("Storage Chest 15", "InvStorage15"),
  chest("Storage Chest 16", "InvStorage16"),
  chest("Storage Chest 17", "InvStorage17"),
  chest("Storage Chest 18", "InvStorage18"),
  chest("Storage Chest 19", "InvStorage19"),
  chest("Storage Chest 20", "InvStorage20"),
  chest("Storage Chest 21", "InvStorage21"),
  chest("Storage Chest 22", "InvStorage22"),
  chest("Storage Chest 23", "InvStorage23"),
  chest("Storage Chest 24", "InvStorage24"),
  chest("Storage Chest 25", "InvStorage25"),
  chest("Storage Chest 26", "InvStorage26"),
  chest("Storage Chest 27", "InvStorage27"),
  chest("Storage Chest 28", "InvStorage28"),
  chest("Dank Paypay Chest"),
  chest("Gelatinous Chest", "InvStorageS"),
  chest("Cheesy Chest", "InvStorageC"),
  chest("Woodlin Chest"),
  chest("Ninja Chest"),
  chest("Cosmic Storage Chest"),
  chest("Holiday Chest"),
  chest("Valenslime Chest", "InvStorageL"),
  chest("Storage Chest 90"),
  chest("Storage Chest 91"),
  chest("Storage Chest 92"),
  chest("Storage Chest 93"),
  chest("Storage Chest 94"),
  chest("Storage Chest 95"),
  chest("Storage Chest 96"),
  chest("Storage Chest 97"),
  chest("Storage Chest 98"),
  chest("Storage Chest 99"),
  chest("Storage Chest 99B"),
  chest("Storage Chest 99C"),
];
